var map = {
	"./Gruppe 4672.svg": 7899,
	"./award.svg": 5998,
	"./brandimage.svg": 4885,
	"./bubbles.svg": 3176,
	"./c_bubble.svg": 5275,
	"./careandcoach_white.svg": 4033,
	"./chat-icon.svg": 3321,
	"./check-circle-2.svg": 6031,
	"./check-circle-fill.svg": 1336,
	"./clock-history.svg": 3884,
	"./creditcards.svg": 8805,
	"./dash-circle.svg": 6248,
	"./diploma-icon.svg": 9831,
	"./download.svg": 9359,
	"./edit.svg": 6343,
	"./element-navigation.svg": 4856,
	"./facebook.svg": 7103,
	"./facebookSocials.svg": 5665,
	"./fullScreenArrows.svg": 1022,
	"./homepage/perks1.svg": 3462,
	"./homepage/perks2.svg": 2597,
	"./homepage/perks3.svg": 7876,
	"./homepage/perks4.svg": 27,
	"./instagram.svg": 6149,
	"./instagramSocials.svg": 2435,
	"./invoice.svg": 7916,
	"./invoice_footer.svg": 7418,
	"./kurgebuehr.svg": 4159,
	"./linkedin.svg": 9705,
	"./linkedinSocials.svg": 3103,
	"./logo-white.svg": 7270,
	"./logo.svg": 3914,
	"./logo_text--white.svg": 301,
	"./logo_text.svg": 1156,
	"./mastercard-white.svg": 755,
	"./newsletter-element-1.svg": 2707,
	"./newsletter-element-2.svg": 7568,
	"./patch-check.svg": 3448,
	"./paypal.svg": 1134,
	"./paypal_footer.svg": 1252,
	"./play-circle-fill.svg": 9396,
	"./play_continue.svg": 4459,
	"./play_module.svg": 3400,
	"./plus-circle.svg": 3248,
	"./quiz-disabled.svg": 789,
	"./quiz-enabled.svg": 9932,
	"./quiz-ending-happy.svg": 7729,
	"./quiz-ending-sad.svg": 3943,
	"./speedometer.svg": 4674,
	"./trophy-icon.svg": 1109,
	"./twitter.svg": 6072,
	"./twitterSocials.svg": 88,
	"./visa-white.svg": 2404,
	"./youtube.svg": 6046,
	"./youtubeSocials.svg": 9818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;